"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastSeenProductIdsStorage = void 0;
var json_storage_item_1 = require("./json-storage-item");
var browser_storage_item_1 = require("./browser-storage-item");
var LastSeenProductIdsStorage = (function () {
    function LastSeenProductIdsStorage() {
        this.key = 'lastSeenProductIds';
        this.storage = new json_storage_item_1.JsonStorageItem(new browser_storage_item_1.BrowserStorageItem(this.key, browser_storage_item_1.StorageType.LOCAL_STORAGE));
    }
    LastSeenProductIdsStorage.prototype.get = function () {
        return this.storage.get() || [];
    };
    LastSeenProductIdsStorage.prototype.add = function (productId) {
        var lastSeenProductIds = new Set(this.get());
        lastSeenProductIds.delete(productId);
        this.storage.set(__spreadArray([productId], Array.from(lastSeenProductIds), true).slice(0, 12));
    };
    return LastSeenProductIdsStorage;
}());
exports.LastSeenProductIdsStorage = LastSeenProductIdsStorage;
//# sourceMappingURL=last-seen-products.js.map